import { render, staticRenderFns } from "./ProgresoVertical.vue?vue&type=template&id=21ab36a4&scoped=true&"
import script from "./ProgresoVertical.vue?vue&type=script&lang=js&"
export * from "./ProgresoVertical.vue?vue&type=script&lang=js&"
import style0 from "./ProgresoVertical.vue?vue&type=style&index=0&id=21ab36a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab36a4",
  null
  
)

export default component.exports